export default __webpack_public_path__ + "afb6c034740a15bbc49abc358d2440f3.png";